import { CheckoutClient } from './checkout-client';

export const metadata = {
  title: 'Checkout | Alqove',
};

export default function CheckoutPage() {
  return <CheckoutClient />;
}
